import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useIntl } from 'react-intl';
import { asStyledComponent } from '@clds/component-enhancer';
import Button from '@cld/button';
import { onExport } from 'actions/export/export';
import { closeWidget } from 'actions/widget';
import { AnalyticsSection } from '@cld/analytics';
import { incomingEvents as outgoingEvents } from '@cld/media-editor-widget';
import { messages } from '../../../../i18n';

const ExportButton = ({ onExport, closeWidget, isDisabled }) => {
  const { formatMessage } = useIntl();
  const label = formatMessage(messages['footer.export']);
  const onExportClick = useCallback(() => {
    closeWidget();
    onExport();
  }, [onExport, closeWidget]);

  return (
    <AnalyticsSection
      data={{
        event: outgoingEvents.DONE,
        label,
      }}
    >
      <Button data-test-specifier="media-editor-widget-export-button" onClick={onExportClick} disabled={isDisabled}>
        {label}
      </Button>
    </AnalyticsSection>
  );
};

const mapDispatchToProps = {
  onExport,
  closeWidget,
};

export default compose(connect(null, mapDispatchToProps), asStyledComponent)(ExportButton);
